const ID = ':id';
const GATE_IN = `in/${ID}`;
const NEW_GATE_IN = 'new-gate-in';
const GATE_OUT = `out/${ID}`;
const NEW_GATE_OUT = 'new-gate-out';

export const INTERMODAL_P = 'intermodal';
export const INTERMODAL_PF = `/${INTERMODAL_P}`;

export const REHEATINGS_P = 'reheatings';
export const REHEATINGS_PF = `${INTERMODAL_PF}/${REHEATINGS_P}`;
export const REHEATING_ID_P = `reheating-detail/${ID}`;
export const REHEATING_ID_PF = `${INTERMODAL_PF}/${REHEATING_ID_P}`;

export const ENTRIES_P = 'entries';
export const ENTRIES_PF = `${INTERMODAL_PF}/${ENTRIES_P}`;
export const GATE_IN_P = `${ENTRIES_P}/${GATE_IN}`;
export const GATE_IN_PF = `${ENTRIES_PF}/${GATE_IN}`;
export const NEW_GATE_IN_P = `${ENTRIES_P}/${NEW_GATE_IN}`;
export const NEW_GATE_IN_PF = `${ENTRIES_PF}/${NEW_GATE_IN}`;
export const GATE_OUT_P = `${ENTRIES_P}/${GATE_OUT}`;
export const GATE_OUT_PF = `${ENTRIES_PF}/${GATE_OUT}`;
export const NEW_GATE_OUT_P = `${ENTRIES_P}/${NEW_GATE_OUT}`;
export const NEW_GATE_OUT_PF = `${ENTRIES_PF}/${NEW_GATE_OUT}`;

export const LOAD_UNLOAD_P = 'load-unload';
export const LOAD_UNLOAD_PF = `${INTERMODAL_PF}/${LOAD_UNLOAD_P}`;
export const LOAD_UNLOAD_ID_P = `${LOAD_UNLOAD_P}/${ID}`;
export const LOAD_UNLOAD_ID_PF = `${INTERMODAL_PF}/${LOAD_UNLOAD_ID_P}`;

export const LOADINGS_P = 'loadings';
export const LOADINGS_PF = `${INTERMODAL_PF}/${LOADINGS_P}`;
export const LOADING_ID_P = `loading-detail/${ID}`;
export const LOADING_ID_PF = `${LOADINGS_PF}/${LOADING_ID_P}`;

export const ON_LOADINGS_P = 'on-loadings';
export const ON_LOADINGS_PF = `${INTERMODAL_PF}/${ON_LOADINGS_P}`;
export const ON_LOADING_ID_P = `on-loading-detail/${ID}`;
export const ON_LOADING_ID_PF = `${ON_LOADINGS_PF}/${ON_LOADING_ID_P}`;

export const EIRS_P = 'eirs';
export const EIRS_PF = `${INTERMODAL_PF}/${EIRS_P}`;
export const EIR_ID_P = `eir-detail/${ID}`;
export const EIR_ID_PF = `${INTERMODAL_PF}/${EIR_ID_P}`;
export const BOL_ID_P = `bol-detail/${ID}`;
export const BOL_ID_PF = `${INTERMODAL_PF}/${BOL_ID_P}`;

export const VESSELS_P = 'vessel';
export const VESSELS_PF = `${INTERMODAL_PF}/${VESSELS_P}`;
export const VESSEL_ID_P = `vessel-detail/${ID}`;
export const VESSEL_ID_PF = `${INTERMODAL_PF}/${VESSEL_ID_P}`;

export const WEIGHBRIDGE_P = 'weighbridges';
export const WEIGHBRIDGE_PF = `${INTERMODAL_PF}/${WEIGHBRIDGE_P}`;
export const WEIGHBRIDGE_ID_P = `weighbridge-detail/${ID}`;
export const WEIGHBRIDGE_ID_PF = `${INTERMODAL_PF}/${WEIGHBRIDGE_ID_P}`;

export const CARGO_P = 'cargo';
export const CARGO_PF = `${INTERMODAL_PF}/${CARGO_P}`;
export const CARGO_ID_P = `cargo-detail/${ID}`;
export const CARGO_ID_PF = (id) => {
  return `${INTERMODAL_PF}/${CARGO_ID_P}`.replace(ID, id)
};

export const DGD_P = 'dgd';
export const DGD_PF = `${INTERMODAL_PF}/${DGD_P}`;
export const DGD_ID_P = `dgd-detail/${ID}`;
export const DGD_ID_PF = (id) => {
  return `${INTERMODAL_PF}/${DGD_ID_P}`.replace(ID, id)
}